<template>
    <input
        id="xxTrustedFormToken_0"
        name="xxTrustedFormToken"
        type="hidden"
    >

    <input
        id="xxTrustedFormCertUrl_0"
        name="xxTrustedFormCertUrl"
        type="hidden"
    >

    <input
        id="xxTrustedFormPingUrl_0"
        name="xxTrustedFormPingUrl"
        type="hidden"
    >

    <noscript>
        <img src="http://api.trustedform.com/ns.gif" alt="" />
    </noscript>
</template>

<script setup>
import {useStore} from 'vuex';
import {onMounted} from 'vue';

const store = useStore();

const fields = [ 'xxTrustedFormToken', 'xxTrustedFormCertUrl', 'xxTrustedFormPingUrl' ];

const addFields = () => {
    fields.forEach(field => {
        store.commit('form/addField', {
            step: 0,
            name: field,
            data: {
                validator: 'notRequired',
                dataType: 'Unspecified',
            },
        });
    })
};

const addScript = () => {
    const field = 'xxTrustedFormCertUrl';
    const provideReferrer = false;
    const invertFieldSensitivity = false;
    const tf = document.createElement('script');
    tf.type = 'text/javascript'; tf.async = true;
    let src = 'http' + ('https:' == document.location.protocol ? 's' : '') +
        '://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
     
    if (store.state.form.attributes.consentTags) {
        src += '&use_tagged_consent=true';
    }
    
    tf.src = src;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(tf, s);
}

const updateFieldsOnFormSubmit = () => {
    store.commit('cro/addBeforeFormSubmitEvent', () => {
        fields.forEach(field => {
            store.commit('form/setFieldData', { name: field, key: 'value', value: document.querySelector(`#${field}_0`).value });
        });
    });
};

onMounted(() => {
    addFields();
    addScript();
    updateFieldsOnFormSubmit();
});
</script>
